/* eslint-disable @intlify/vue-i18n/no-dynamic-keys */
const CALLBACK_ERROR_TYPE_BY_PARAM = {
  access_denied: 'USER_DENIED',
  authorization_denied: 'USER_DENIED',
  user_denied: 'USER_DENIED',
  invalid_scope: 'INVALID_SCOPE',
  missing_permission: 'MISSING_PERMISSION',
  permissions_error: 'MISSING_PERMISSION',
  account_not_found: 'ACCOUNT_NOT_FOUND',
  account_disconnected: 'ACCOUNT_NOT_FOUND',
  invalid_token: 'TOKEN_INVALID',
  token_expired: 'TOKEN_INVALID',
  expired_token: 'TOKEN_INVALID',
  provider_unavailable: 'PROVIDER_UNAVAILABLE',
  service_unavailable: 'PROVIDER_UNAVAILABLE',
  temporarily_unavailable: 'PROVIDER_UNAVAILABLE',
  callback_error: 'CALLBACK_ERROR',
  internal_error: 'CALLBACK_ERROR',
};

export const normalizeSocialChannelCallbackErrorType = errorType => {
  const normalizedType = String(errorType || '')
    .trim()
    .toLowerCase();
  return CALLBACK_ERROR_TYPE_BY_PARAM[normalizedType] || 'UNKNOWN';
};

export const redactSensitiveOAuthDetails = value =>
  String(value || '')
    .replace(
      /\b(code|token|access_token|refresh_token|authorization_code|client_secret)(=|%3D|:)([^&\s]+)/gi,
      '$1=[redacted]'
    )
    .replace(/\b(Bearer)\s+[A-Za-z0-9._~+/-]+=*/gi, '$1 [redacted]')
    .replace(/[A-Za-z0-9_-]{48,}/g, '[redacted]')
    .trim();

const providerDetails = errorMessage => {
  const details = redactSensitiveOAuthDetails(errorMessage);
  return details.length > 240 ? `${details.slice(0, 237)}...` : details;
};

export const buildSocialChannelCallbackError = ({
  channelKey,
  errorType,
  errorMessage,
  t,
}) => {
  if (!errorType && !errorMessage) return null;

  const normalizedType = normalizeSocialChannelCallbackErrorType(errorType);
  const baseKey = `INBOX_MGMT.ADD.${channelKey}.CALLBACK_ERRORS`;
  const details = providerDetails(errorMessage);
  const description = t(`${baseKey}.${normalizedType}.DESCRIPTION`);

  return {
    type: normalizedType,
    message: t(`${baseKey}.${normalizedType}.TITLE`),
    description: details
      ? `${description} ${t(`${baseKey}.DETAILS`, { details })}`
      : description,
    action: t(`${baseKey}.${normalizedType}.ACTION`),
    actionLabel: t(`${baseKey}.ACTION_LABEL`),
  };
};
